import { useState, useEffect } from "react";
import { Box, Grid, Tab } from "@mui/material";
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { getEnumSingleData, getEnumsLoading } from '../selector/selectors';
import {  loadEnumEditData } from "../api/enumsapi";
import LoaderComponent from "../components/LoaderComponent";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import EnumsGrid from "../components/EnumsGrid";


const EditEnums = ({
    isLoading,
    enumData,
    loadEnumEditData
}) => {
    const params                            =   useParams();
    const [value, setValue]                 =   useState('1');

    useEffect(() => {
       loadEnumEditData(params.id);
    }, [loadEnumEditData,params.id]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
    <Box sx={{ flexGrow: 1 }} >
        { isLoading ?  <LoaderComponent />: <></>}
        <Grid container >
            <TabContext value={value}>
                <Grid item xs={12} md={12} lg={12} >
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList onChange={handleChange} aria-label="">
                            <Tab label="Edit Enums Data" value="1" />
                        </TabList>
                    </Box>
                    <TabPanel value="1" sx={{p:0,pt:2}}>
                        {enumData?.data?.length > 0 &&
                            <EnumsGrid
                                result={enumData?.data}
                            />
                        }
                    </TabPanel>
                </Grid>
            </TabContext>
        </Grid>
    </Box>
  );
}

const mapStateToProps = (state) => ({
    isLoading: getEnumsLoading(state),  
    enumData:getEnumSingleData(state)
});
const mapDispatchToProps = (dispatch) => ({
    loadEnumEditData:(id)      => dispatch(loadEnumEditData(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditEnums); 